import { Modal } from '@orbind/ui'
import { useEffect, useState } from 'react'
import {
  garantirPermissao,
  ouvirPedidoDePermissao,
  type TipoDePermissao,
} from '../features/app/desktop-permissoes.ts'
import { escutarDoDesktop } from '../features/app/desktop-eventos.ts'
import { isDesktop } from '../lib/platform.ts'
import './permissao.css'

/**
 * Diálogo de permissão do próprio Orbind (SPEC-20260916-2335).
 *
 * Mora no shell porque a chamada pode começar em qualquer tela. Ele responde a
 * dois caminhos: o pedido que a própria tela faz antes de usar a mídia
 * (`garantirPermissao`) e o aviso do shell quando algo pediu a mídia sem
 * decisão guardada (evento `orbind://permissao-pedida`) — nesse caso o motor
 * já negou, e o "Permitir" aqui grava para a próxima tentativa passar.
 */

const TEXTO: Record<TipoDePermissao, { titulo: string; corpo: string; icone: string }> = {
  microfone: {
    titulo: 'Usar o microfone?',
    corpo: 'O Orbind precisa do microfone para você falar nas chamadas. Você pode mudar isso depois em Preferências.',
    icone: 'fas fa-microphone',
  },
  camera: {
    titulo: 'Usar a câmera?',
    corpo: 'O Orbind precisa da câmera para mostrar sua imagem nas chamadas e para tirar a foto do grupo. Você pode mudar isso depois em Preferências.',
    icone: 'fas fa-video',
  },
}

export function PermissaoDeMidia() {
  const [pedido, setPedido] = useState<{ tipo: TipoDePermissao; responder: (v: boolean) => void } | null>(null)

  useEffect(() => ouvirPedidoDePermissao(setPedido), [])

  // O shell avisa quando algo pediu a mídia sem decisão guardada: pergunta
  // aqui e grava, para a próxima tentativa já passar.
  useEffect(() => {
    if (!isDesktop()) return
    return escutarDoDesktop<{ tipo: string }>('orbind://permissao-pedida', (evento) => {
      if (evento.tipo === 'microfone' || evento.tipo === 'camera') void garantirPermissao(evento.tipo)
    })
  }, [])

  if (!pedido) return null
  const texto = TEXTO[pedido.tipo]

  return (
    <Modal
      open
      onClose={() => pedido.responder(false)}
      title={texto.titulo}
      width={420}
      footer={
        <div className="perm__rodape">
          <button type="button" className="ob-btn ob-btn--ghost" onClick={() => pedido.responder(false)}>
            Agora não
          </button>
          <button type="button" className="ob-btn ob-btn--primary" onClick={() => pedido.responder(true)}>
            Permitir
          </button>
        </div>
      }
    >
      <div className="perm">
        <span className="perm__icone" aria-hidden>
          <i className={texto.icone} />
        </span>
        <p className="perm__texto">{texto.corpo}</p>
      </div>
    </Modal>
  )
}
